module.exports = __webpack_public_path__ + "94f246359e4652555d87241ef4d5b9c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qyrwm.jpg
// module id = 273
// module chunks = 1